/**
 * charma-premium-silver.js
 * Вставляет премиальный блок Ag 925 на карточку товара для серебряных изделий.
 *
 * Подключение в theme.liquid перед </body>:
 *   <script src="{{ 'charma-premium-silver.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  if (!window.location.pathname.includes('/products/')) return;

  var CSS = [
    '.ch-premium{border:0.5px solid #c2cad0;border-radius:12px;padding:16px;background:#f7f9fb;margin-bottom:16px}',
    '.ch-premium-header{display:flex;align-items:center;gap:12px;margin-bottom:14px;padding-bottom:14px;border-bottom:0.5px solid #dde3e8}',
    '.ch-stamp{width:46px;height:46px;border-radius:50%;border:1.5px solid #9caab5;display:flex;align-items:center;justify-content:center;flex-shrink:0;background:#fff}',
    '.ch-stamp span{font-size:10px;font-weight:700;color:#6b7a87;text-align:center;line-height:1.25;letter-spacing:.03em}',
    '.ch-premium-title{font-size:13.5px;font-weight:600;color:#1a1a2e;margin-bottom:3px;line-height:1.3}',
    '.ch-premium-sub{font-size:12px;color:#6b7a87;line-height:1.4}',
    '.ch-specs{display:grid;grid-template-columns:1fr 1fr;gap:7px}',
    '.ch-spec{display:flex;align-items:center;gap:9px;background:#fff;border:0.5px solid #dde3e8;border-radius:8px;padding:9px 11px}',
    '.ch-spec-ico{width:28px;height:28px;border-radius:6px;background:#f0f4f7;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:14px}',
    '.ch-spec-lbl{font-size:11px;color:#8a9aaa;line-height:1.2;margin-bottom:2px}',
    '.ch-spec-val{font-size:12.5px;font-weight:600;color:#1a1a2e;line-height:1.2}'
  ].join('');

  function inject() {
    // Проверяем серебряный ли продукт
    var h1 = document.querySelector('h1');
    if (!h1 || !h1.textContent.includes('925')) return;

    // Уже вставлен
    if (document.querySelector('.ch-premium')) return;

    // Точка вставки — список бейджей доверия
    var anchor = document.querySelector('ul.icon-with-text');
    if (!anchor) return;

    // Читаем характеристики из таблицы в описании
    var specs = {};
    document.querySelectorAll('table tbody tr').forEach(function (row) {
      var cells = row.querySelectorAll('td');
      if (cells.length >= 2) specs[cells[0].textContent.trim()] = cells[1].textContent.trim();
    });

    var purity   = (specs['Próba srebra'] || specs['Rýdzosť striebra'] || 'Ag 925').replace('/1000', '');
    var diameter = specs['Średnica otworu'] || specs['Priemer prievlaku'] || null;
    var weight   = specs['Waga'] || specs['Váha']              || null;
    var isPandora = document.body.textContent.includes('Pandora');

    var icoAg = '<span style="font-size:9px;font-weight:800;color:#6b7a87;letter-spacing:-.3px">Ag</span>';
    var items = [{ ico: icoAg, label: 'Rýdzosť', value: purity }];
    if (diameter)  items.push({ ico: '⬤', label: 'Prievlak', value: diameter });
    if (weight)    items.push({ ico: '◆',  label: 'Váha',     value: weight });
    if (isPandora) items.push({ ico: '✓',  label: 'Pandora',  value: 'Kompatibilné' });

    var specsHTML = items.map(function (s) {
      return '<div class="ch-spec">' +
        '<div class="ch-spec-ico">' + s.ico + '</div>' +
        '<div>' +
          '<div class="ch-spec-lbl">' + s.label + '</div>' +
          '<div class="ch-spec-val">' + s.value + '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    var blockHTML =
      '<div class="ch-premium">' +
        '<div class="ch-premium-header">' +
          '<div class="ch-stamp"><span>Ag<br>925</span></div>' +
          '<div>' +
            '<div class="ch-premium-title">Certifikované striebro najvyššej kvality</div>' +
            '<div class="ch-premium-sub">Pečať pravosti Ag 925 · Pravé striebro · Hypoalergénne</div>' +
          '</div>' +
        '</div>' +
        '<div class="ch-specs">' + specsHTML + '</div>' +
      '</div>';

    if (!document.getElementById('ch-premium-style')) {
      var style = document.createElement('style');
      style.id = 'ch-premium-style';
      style.textContent = CSS;
      document.head.appendChild(style);
    }

    if ((document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0) { var plCopies = {"Certifikované striebro najvyššej kvality":"Certyfikowane srebro najwyższej jakości","Pečať pravosti Ag 925 · Pravé striebro · Hypoalergénne":"Oznaczenie próby Ag 925 · Prawdziwe srebro · Hipoalergiczne","Rýdzosť":"Próba","Prievlak":"Otwór","Váha":"Waga","Kompatibilné":"Kompatybilne"}; Object.keys(plCopies).sort(function(a,b){return b.length-a.length;}).forEach(function(s){ blockHTML = blockHTML.split(s).join(plCopies[s]); }); }
    anchor.insertAdjacentHTML('beforebegin', blockHTML);
  }

  // Пробуем сразу, потом через таймеры — Dawn рендерит ul.icon-with-text асинхронно
  function tryInject() {
    inject();
    if (!document.querySelector('.ch-premium')) {
      setTimeout(inject, 300);
      setTimeout(inject, 800);
      setTimeout(inject, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInject);
  } else {
    tryInject();
  }
})();
